/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_NavigationInputs */

const he_command_navigation = /** @type {(inputs: Command_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ניווט`)
};

const en_command_navigation = /** @type {(inputs: Command_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation`)
};

/**
* | output |
* | --- |
* | "Navigation" |
*
* @param {Command_NavigationInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const command_navigation = /** @type {((inputs?: Command_NavigationInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_NavigationInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_command_navigation(inputs)
	return en_command_navigation(inputs)
});